const styles = {
  container: { padding: '30px', minHeight: '100vh', backgroundColor: '#f4f6f9', fontFamily: 'Segoe UI, sans-serif' },
  header: { color: '#1B019B', fontWeight: '600', fontSize: '1.5rem' },
  hr: { width: '80px', border: '2px solid #1B019B', opacity: '1', margin: '10px auto' },
  organisationHeader: { 
    backgroundColor: '#fff', 
    padding: '20px', 
    borderRadius: '12px', 
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  tableHeader: { backgroundColor: '#1B019B', color: '#fff' },
  paginationButton: { backgroundColor: '#1B019B', color: 'white', border: 'none', margin: '0 2px', borderRadius: '5px', padding: '5px 10px', cursor: 'pointer' },
  paginationActive: { backgroundColor: '#0d0066', color: 'white' },
  paginationDisabled: { backgroundColor: '#e0e0e0', color: '#a0a0a0', cursor: 'not-allowed' },
  searchBar: { maxWidth: '200px', borderRadius: '20px', paddingLeft: '10px', height: '35px', border: '1px solid #ccc', fontSize: '1rem' },
  select: { borderRadius: '20px', height: '35px', padding: '0 10px', fontSize: '1rem' },
  dateInput: { borderRadius: '20px', height: '35px', padding: '0 10px', fontSize: '1rem', border: '1px solid #ccc' },
  icon: { marginRight: '5px' },
  positiveSolde: { color: '#28a745', fontWeight: 'bold' },
  negativeSolde: { color: '#dc3545', fontWeight: 'bold' },
  zeroSolde: { color: '#6c757d', fontWeight: 'bold' },
  card: { padding: '20px', borderRadius: '15px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '5px', minHeight: '120px', transition: 'all 0.3s ease', cursor: 'pointer' },
  positiveCard: { backgroundColor: '#e8f5e9', color: '#28a745' },
  negativeCard: { backgroundColor: '#fdecea', color: '#dc3545' }
};

export default styles;